import { render } from "./FAQ2.vue?vue&type=template&id=12820ac2&lang=true"
import script from "./FAQ2.vue?vue&type=script&lang=js"
export * from "./FAQ2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__